// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"_2Y8Hn","effectsGrayscale30":"As0LF","resetList":"xAAKr","formRow":"_3LM6B","message":"_3PsUM","wordCountWarning":"_2-xoz"};